import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { WizardPage } from './wizard.page';

const routes: Routes = [
  {
    path: '',
    component: WizardPage
  }
];

@NgModule({
    imports: [CommonModule, FormsModule, IonicModule, RouterModule.forChild(routes), WizardPage],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class WizardPageModule {}
